import { Box, Typography } from "@mui/material";
import PageTitle from "../../components/Page Component/PageTitle";
import ReviewEmployeesSkills from "./ReviewEmployeesSkills";

const ReviewSkills = () => {
  return (
    <Box sx={{ width: "100%", mt: 10, mb: 10 }}>
      <Box sx={{ mb: 3, px: 2 }}>
        <PageTitle>Review Skills</PageTitle>
        <Typography variant="body1" color="textSecondary" sx={{ mt: 2 }}>
          Review employee skill ratings
        </Typography>
      </Box>
      <ReviewEmployeesSkills />
    </Box>
  );
};

export default ReviewSkills;
